import styled from "styled-components";
import { FaBars, FaSearch, FaTimes, FaBell, FaFileUpload } from "react-icons/fa";
import {FiFilePlus} from "react-icons/fi"
import {HiUpload} from "react-icons/hi"
import {FaUpload} from "react-icons/fa"
import {MdUnarchive} from "react-icons/md"
import { hexToRgba } from "../HexToRGBA";
import { MEDIA_SCREEN } from "../../utils/Enum";
import { BsCollectionPlayFill } from "react-icons/bs";
import { RiPlayListFill } from "react-icons/ri";
import { Link } from "react-router-dom";


export const Nav = styled.nav`
display: flex;
  background-color: ${(props) =>
    props.scrollNav ? hexToRgba(props.theme.mainColor, 0.7) : 'transparent'};
  height: 2vh;
  max-width: 100%;
  align-content: flex-start;
  align-items: center;
  justify-content: space-evenly;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(8px);
  position: sticky;
  padding: 2% 6%;
  top: 0;
  z-index: 20;
  transition: all 0.2s ease-in-out;
  //border-bottom: 1px solid ${(props) => props.scrollNav ? props.theme.secondaryColor : props.theme.mainColor};
  color: ${(props) =>
    props.scrollNav ? props.theme.mainBg : props.theme.secondaryColor};
`;

export const NavLink = styled(Link)`
color: ${(props) => props?.scrollNav ?  props.theme.secondaryBg : props.theme.mainColor}; 
display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 2% 1rem;
  font-size: 0.9rem;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    border-radius: 50px;
    transition: all 0.3s ease-in-out;
    background: ${(props) => props?.scrollNav ?  props.theme.secondaryBg : props.theme.mainColor};
    color: ${(props) => props?.scrollNav ?  props.theme.mainColor : props.theme.secondaryBg}; 
  }
`;
export const NavLinkA = styled.a`
  color: ${(props) => props.scrollNav ? props.theme.mainBg: props.theme.accentColor}; 
  display: flex;
  align-items: center;
  text-align: center;
  text-decoration: none;
  padding: 2%  1rem;
  font-size: 0.8rem;
  height: 100%;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  
  &:active {
    border-bottom: 3px solid ${(props) => props.theme.mainColor};
  }

  &:hover {
    border-radius: 50px;
    transition: all 0.3s ease-in-out;
    background: ${(props) => props.theme.mainColor};
  }
`;

export const NavContainer = styled.div`
  display: flex;
  margin-top: 0;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
 
`;

export const NavLogo = styled(Link)`
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1%;
  height: 2.1rem;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  font-weight: 700;
  
  &:hover{
    transform: scale(1.07);
    transition: 1s ease-out;
}

`;

export const Img = styled.img`
  border-radius: 50%;

`;

export const NavImg = styled.img`
  position: relative;
  height: 3.5rem;
  width: auto;
  &:hover {
    transition: 1s ease-out;
  }
  @media screen and (max-width: 760px){
    height: 2rem;
  }
`;

export const Bars = styled(FaBars)`
    display: none;

    @media screen and (max-width: 768px){
        display: flex;
        position: relative;
        margin-left: 6%;
        font-size: 1.5rem;
        cursor: pointer;
        color: ${(props) =>
          props.scrollNav ? props.theme.mainBg : props.theme.secondaryColor};

          &:hover{
            transform: scale(1.07);
            transition: 1s ease-out;
        }

`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-around;
  white-space: nowrap;
  padding: 2% 2%;
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const SearchContainer =styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  justify-items: flex-end;
  justify-self: center;
  transition: all 0.2s;
  font-size: 1.2rem;
  flex: 1 1 50%;
  padding: 2% 2%;
`

export const SearchBtn = styled(FaSearch)`
  display: ${props => (props.toggle? 'none' : 'flex')};
  cursor: pointer;
  justify-content: flex-end;
 
  transition: all 0.2s;
  &:hover {
    transform: scale(1.07);
    transition: 1s ease-out;
    color: ${(props) => props.theme.mainColor};
  }
 
  @media screen and (max-width: 768px) {
    font-size: 1rem;    
    
  }

`
export const NotificationButton = styled(FaBell)`
  display: flex;
  cursor:pointer;
  
  &:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.2)
  }

`

export const MusicUploadsButton = styled(FaFileUpload)`
display: flex;
padding: 2px;
font-size: 1.5rem;
color: ${(props) =>
  props.scrollNav ? props.theme.mainBg : props.theme.secondaryColor};
cursor:pointer;
  &:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.2)
  }

`
export const NFTokenCollectionButton = styled(BsCollectionPlayFill)`
display: flex;
padding: 2px;
font-size: 1.5rem;
color: ${(props) =>
  props.scrollNav ? props.theme.mainBg : props.theme.secondaryColor};
cursor:pointer;
  &:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.2)
  }

`
export const PlaylistBtn = styled(RiPlayListFill)`
display: flex;
padding: 2px;
font-size: 1.5rem;
color: ${(props) =>
  props.scrollNav ? props.theme.mainBg : props.theme.secondaryColor};
cursor:pointer;
  &:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.2)
  }

`


export const CloseIcon = styled(FaTimes)`
display: ${props => (props.toggle? 'flex' : 'none')};
font-size: 1.3rem;
margin-left: 1%;
position: relative;

@media screen and (max-width: 768px) {
  font-size: 2rem;
  margin-left: 3%;
  padding: 0 1%;
}
`

export const NavBtnLink = styled(Link)`
  display: flex;
  white-space: nowrap;
  border-radius: 50px;
  font-size: 0.8rem;
  background: ${(props) =>
    props.scrollNav ? props.theme.secondaryBg : props.theme.mainColor};
    padding: 2% 1rem;
    color: ${(props) =>
    props.scrollNav ? props.theme.mainColor : props.theme.secondaryBg};
  border: 2px solid ${(props) => props.theme.mainColor};
  outline: none;
  cursor: pointer;
  padding: 5%  1rem;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin-left: 5%;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${(props) => props.theme.secondaryBg};
    border: 2px solid ${(props) => props.theme.secondaryBg};
    color: ${(props) => props.theme.mainColor};
  }
  @media screen and (max-width: 480px) {
    display: none;
  }
`;
